import { render, staticRenderFns } from "./TeethSelector.vue?vue&type=template&id=254211c2&scoped=true"
import script from "./TeethSelector.vue?vue&type=script&lang=js"
export * from "./TeethSelector.vue?vue&type=script&lang=js"
import style0 from "./TeethSelector.vue?vue&type=style&index=0&id=254211c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254211c2",
  null
  
)

export default component.exports